import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Backdrop, Grow, Modal } from '@material-ui/core';
import '../../assets/css/timeline.css';
import Timezone from '../../commons/timezone/Timezone.js';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';
import { etiquetaEstado } from './solicitudEstado.js';

const ICONO_EVENTO = {
	PENDIENTE: 'la la-file-text-o',
	LIBERADA: 'la la-ticket',
	RECHAZADA: 'la la-thumbs-o-down',
	CANCELADA: 'la la-ban',
};

const SolicitudHistorialModal = ({ solicitud, onClose }) => {
	const intl = useIntl();

	if (!solicitud) return null;

	const titulo = (evento) => {
		if (evento.estadoAnterior === null) {
			return intl.formatMessage({ id: 'solicitudHistorial.alta', defaultMessage: 'Alta de la solicitud' });
		}
		switch (evento.estadoNuevo) {
			case 'LIBERADA':
				return intl.formatMessage({ id: 'solicitudHistorial.liberada', defaultMessage: 'Solicitud liberada' });
			case 'RECHAZADA':
				return intl.formatMessage({ id: 'solicitudHistorial.rechazada', defaultMessage: 'Solicitud rechazada' });
			case 'CANCELADA':
				return intl.formatMessage({ id: 'solicitudHistorial.cancelada', defaultMessage: 'Solicitud cancelada' });
			default:
				return etiquetaEstado(intl, evento.estadoNuevo);
		}
	};

	const detalle = (evento) => {
		const partes = [];
		if (evento.estadoAnterior === null) {
			partes.push(intl.formatMessage({ id: 'solicitudHistorial.estado_inicial', defaultMessage: 'Estado: {estado}' }, { estado: etiquetaEstado(intl, evento.estadoNuevo) }));
		} else {
			partes.push(
				intl.formatMessage(
					{ id: 'solicitudHistorial.cambio_estado', defaultMessage: 'Estado: {anterior} → {nuevo}' },
					{ anterior: etiquetaEstado(intl, evento.estadoAnterior), nuevo: etiquetaEstado(intl, evento.estadoNuevo) }
				)
			);
		}
		if (evento.motivo) {
			partes.push(intl.formatMessage({ id: 'solicitudHistorial.motivo', defaultMessage: 'Motivo: {motivo}' }, { motivo: evento.motivo }));
		}
		if (evento.comentario) {
			partes.push(intl.formatMessage({ id: 'solicitudHistorial.comentario', defaultMessage: 'Comentario: {comentario}' }, { comentario: evento.comentario }));
		}
		return partes.join(' - ');
	};

	const historial = (solicitud.historial || []).slice().reverse();

	return (
		<Modal open={!!solicitud} onClose={onClose} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 300 }}>
			<Grow in={!!solicitud}>
				<div tabIndex="-1" role="dialog">
					<div className="modal-xl modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header bg-fleet">
								<h4 className="modal-title text-white mb-0">
									<i className="la la-history align-middle icon-modal-title"></i>{' '}
									<FormattedMessage id="solicitudHistorialModal.titulo_historico_solicitud" defaultMessage="Histórico de la Solicitud: {numero}" values={{ numero: solicitud.numero }} />
								</h4>
								<button type="button" className="close" aria-label="Close" onClick={onClose}>
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body modal-grey modal-mh ovf-x-hidden">
								<div className="content-wrapper">
									<div className="content-body">
										<section id="timeline" className="timeline-left timeline-wrapper">
											<ul className="timeline">
												<li className="timeline-line"></li>
												{historial.map((evento, index) => (
													<li key={index} className={evento.estadoAnterior === null ? 'timeline-item' : 'timeline-item status-change'}>
														<div className="timeline-badge">
															<span className="bg-fleet bg-lighten-1">
																<i className={ICONO_EVENTO[evento.estadoNuevo] || 'la la-history'}></i>
															</span>
														</div>
														<div className="timeline-card card border-grey border-lighten-2 card-history">
															<div className="card-header">
																<h4 className="card-title">
																	{LocaleFormat.formatDateTime(Timezone.getDateForClient(evento.fechaHora)) + ' - ' + titulo(evento) + ' - ' + evento.usuario}
																</h4>
																<p className="card-subtitle text-muted pt-1">
																	<span className="font-small-3" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{detalle(evento)}</span>
																</p>
															</div>
														</div>
													</li>
												))}
											</ul>
										</section>
									</div>
								</div>
							</div>
							<div className="modal-footer modal-grey">
								<button type="button" className="btn btn-default btn-fleet" onClick={onClose}>
									<FormattedMessage id="solicitudHistorialModal.ok" defaultMessage="Ok" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</Grow>
		</Modal>
	);
};

export default SolicitudHistorialModal;
